import { ILink, TLink } from '../../types/links';
import { help } from './components/help';
import { legalDocuments } from './components/legalDocuments';
import { price } from './components/price';
import { fairplay } from './components/fairplay';
import { advert } from './components/advert';
import { career } from './components/career';
import { newOffers } from './components/newOffers';
import { auction } from './components/auction';
import { legalCheck } from './components/legalCheck';
import { mortgageCalculator } from './components/mortgageCalculator';
import { promo } from './components/promo';
import { searchOnMap } from './components/searchOnMap';
import { sitemap } from './components/sitemap';
import { vacancies } from './components/vacancies';
import { tv } from './components/tv';
import { contacts } from './components/contacts';

export const LINKS: { [key in TLink]: ILink } = {
  auction,
  contacts,
  legalCheck,
  mortgageCalculator,
  promo,
  searchOnMap,
  sitemap,
  tv,
  vacancies,
  advert,
  help,
  legalDocuments,
  fairplay,
  newOffers,
  price,
  career,
};
